import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useState } from "react";
import AddEditCustomerDialog from "../../../../pages/SettingsPage/Clients/CustomerPage/AddCustomerDialog/AddEditCustomerDialog";
import { IconButton } from "@mui/material";
import { useFeature } from "../../../../hooks";

const AddClientButtonAndModal = () => {
  const [showAddCustomerDialog, setShowAddCustomerDialog] = useState(false);
  const addCustomerEnabled = useFeature("add-customer");

  if (!addCustomerEnabled) {
    return null;
  }

  return (
    <>
      {showAddCustomerDialog && (
        <AddEditCustomerDialog
          id={"NEW"}
          onClose={() => setShowAddCustomerDialog(false)}
        />
      )}
      <IconButton onClick={() => setShowAddCustomerDialog(true)}>
        <AddCircleOutlineIcon />
      </IconButton>
    </>
  );
};

export default AddClientButtonAndModal;
